import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const GET_PROPERTY_TYPE_API = `${LOCAL_URL}/property/propertyType`
export const GET_CARPET_AREA_UNIT_API = `${LOCAL_URL}/property/carpetAreaUnit`
export const GET_COUNTRY_API = `${LOCAL_URL}/getCountry`
export const GET_PROVINCE_API = `${LOCAL_URL}/getProvince`
export const SEARCH_API = `${LOCAL_URL}/admin/searchUserAdmin`
export const GET_PROPERTY_USER = `${LOCAL_URL}/admin/user/listUsersProp`
export const CREATE_SUPERADMIN_PROPERTY_API = `${LOCAL_URL}/admin/createPropertyAdmin`

const headers = {
  Authorization: API_TOKEN,
}

//axios call to get property type
export async function Get_Property_Type() {
  const headers = {
    Authorization: API_TOKEN,
    //'Authorization': `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
  }
  return await axios.post(
    GET_PROPERTY_TYPE_API,

    {
      headers,
    }
  )
}

// function to get carpet area unit
export async function Get_Carpet_Unit() {
  const headers = {
    Authorization: API_TOKEN,
    // 'Authorization': `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
  }
  return await axios.post(
    GET_CARPET_AREA_UNIT_API,

    {
      headers,
    }
  )
}

// function get country

export async function Get_Country() {
  return await axios.get(GET_COUNTRY_API)
}

// FUNCTION  TO GET Province

export async function Get_Province(country_id: number) {
  return await axios.post(GET_PROVINCE_API, {country_id})
}

//axios call to search email id '

export async function Search(email_id: string) {
  return await axios.post(SEARCH_API, {email_id})
}

//axios call to get property list using acciunt uuid

export async function GetUserPropertyList(obj: string) {
  let data = {
    account_uuid: obj,
  }
  return await axios.post(GET_PROPERTY_USER, data, {
    headers: {...headers},
  })
}


// function to creacte property
export async function Create_Property_Admin(
  property_type_uuid: string,
  property_title: string,
  carpet_area: number,
  carpet_area_unit_uuid: string,
  address_1: string,
  address_2: string,
  country_id: number,
  province_id: number,
  city: string,
  pin_zip: number,
  current_rent: number,
  isAgent: boolean,
  user_name: string,
  user_email_id: string,
  user_contact_number: string
) {
  return await axios.post(CREATE_SUPERADMIN_PROPERTY_API, {
    property_type_uuid,
    property_title,
    carpet_area,
    carpet_area_unit_uuid,
    address_1,
    address_2,
    country_id,
    province_id,
    city,
    pin_zip,
    current_rent,
    isAgent,
    user_name,
    user_email_id,
    user_contact_number,
  })
}